import "./About.css";
import { FiMail, FiGitPullRequest, FiGithub } from "react-icons/fi";

const About = () => {
    return (
        <section className="about-container" id="about">
            <div className="profile-card">
                <div className="profile-top">
                    <div className="avatar-ring">
                        <img className="avatar-img" src="https://avatars.githubusercontent.com/u/126952815?v=4" alt="Sakamochan" />
                    </div>

                    <div className="profile-info">
                        <h2 className="profile-name">Sakamochan</h2>
                        <p className="profile-handle">@sakamochan123</p>

                        <hr className="profile-divider" />

                        <div className="profile-links">
                            <a href="mailto:Sakamochan123@outlook.com"><FiMail /></a>
                            <a href="https://qiita.com/Sakamochan" target="_blank"><FiGitPullRequest /></a>
                            <a href="https://github.com/sakamochanq" target="_blank"><FiGithub /></a>
                        </div>
                    </div>
                </div>
                <p className="profile-bio">
                    金沢市在住。空間情報工学専攻の大学生。アイディアというのは恥ずかしいので、<b>思いついたものを形にすることが好き</b>とでも言っておきます。
                    ジャンルは縛りません。プログラミングをしたり、3Dモデリングをしたり、画像や動画を作ったり、いろいろやります。
                    好きな漫画は チェンソーマン と 宝石の国。最近は 呪術廻戦≡ も好き。
                </p>
            </div>
        </section>
    );
}

export default About;